import * as React from 'react';
import dayjs from 'dayjs';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import type { ApplicationViewTableDataItem } from '../../../../Application/components';

export type TooltipDataCellProps = {
  data: string;
  tooltip: string;
};

export const gsSubmissionTimeCell = (
  row: ApplicationViewTableDataItem,
): React.ReactNode => {
  const gsSubmissionTime = row.gsSubmissionTime ?? [];

  const lastSubmitAt = gsSubmissionTime?.[gsSubmissionTime.length - 1]?.at;
  const firstSubmitAt = gsSubmissionTime?.[0]?.at;
  const result = dayjs(lastSubmitAt).format('DD/MM/YYYY,HH:mm');

  let hover: string = '';
  if (firstSubmitAt !== lastSubmitAt) {
    hover = `(First Submission: ${dayjs(firstSubmitAt).format('DD/MM/YYYY,HH:mm:ss')})`;
  }
  return (
    <span className="flex flex-col items-center">
      {Boolean(hover) && (
        <Tooltip title={hover}>
          <span>
            <InfoOutlined sx={{ width: '1rem', marginRight: '0.25rem' }} />
          </span>
        </Tooltip>
      )}
      {result}
    </span>
  );
};
